import { SkeletonParameters } from '@agilelab/plugin-wb-catalog-extension-common';
import z from 'zod';

export const SkeletonParametersValidator = z.object({
  parameters: z.record(z.any()),
  values: z.record(z.any()).optional(),
  readonly: z.record(z.any()).optional(),
  environmentParameters: z.record(z.record(z.any())).optional(),
  overrides: z.record(z.any()).optional(),
});

export const ComputeSkeletonEntityUpdatesRequestSchema = z.object({
  currentSkeleton: z.object({
    catalogInfo: z.string(),
    parameters: SkeletonParametersValidator,
  }),
  upserts: z.object({
    parameters: SkeletonParametersValidator.partial(),
  }),
  computeRenderedData: z.boolean(),
});

export type ComputeSkeletonEntityUpdatesRequest = z.infer<
  typeof ComputeSkeletonEntityUpdatesRequestSchema
>;

export type ComputeSkeletonEntityUpdatesResponse = {
  updatedSkeleton: {
    parameters: SkeletonParameters;
  };
  renderedData?: {
    catalogInfo: Record<string, any>;
  };
};
